import { render, staticRenderFns } from "./ProductStockStatus.vue?vue&type=template&id=cc63f962&scoped=true&"
import script from "./ProductStockStatus.vue?vue&type=script&lang=js&"
export * from "./ProductStockStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc63f962",
  null
  
)

export default component.exports